// axios.js
import axios from 'axios'
import commonAxios from './axios.config'

const getToken = async () => {
  const cookieStr = document.cookie
  const cookies = cookieStr.split(';').reduce((acc, cookie) => {
    const [key, value] = cookie.trim().split('=')
    acc[key] = decodeURIComponent(value)
    return acc
  }, {})
  let token = cookies['dynamodb_jwt_token']
  if (!token) {
    try {
      const res = await commonAxios.get('/users/comments_token')
      token = res.data?.dynamodbJwtToken
      if (token) {
        document.cookie = `dynamodb_jwt_token=${encodeURIComponent(
          token
        )}; path=/`
      }
    } catch (err) {
      console.log(err)
    }
  }
  return token
}

const commentAxios = axios.create({
  baseURL:
    window?.REACT_ENV_VARIABLES?.COMMENTS_BASE_URL ||
    'https://svc-cr.dev.alomoves.software'
})

commentAxios.interceptors.request.use(async (config) => {
  const token = await getToken()
  config.headers['Authorization'] = `Bearer ${token}`
  return config
})

export default commentAxios
